import { render, staticRenderFns } from "./PermissionsError.vue?vue&type=template&id=5cd2bad4"
import script from "./PermissionsError.vue?vue&type=script&lang=ts"
export * from "./PermissionsError.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports